/**
 * A date of birth: ./DateInput over `birthDateRange` — today at the latest,
 * 120 years back at the earliest, opening thirty years back.
 */
import { useMemo } from 'react';

import { DateInput, type DateInputProps } from './DateInput';
import { birthDateRange } from './dateField';

export function BirthDateInput(props: Omit<DateInputProps, 'range'>) {
  // Today as of opening the form, like every other bound on it.
  const range = useMemo(() => birthDateRange(), []);
  return <DateInput {...props} range={range} />;
}
